import React from 'react';
import { gluteSteps } from '../../data/gluteCopy';
export function GluteMethod() {
  return <section aria-labelledby="glute-como" className="w-full bg-coal-deep" data-id="element-95" data-mp="2dw0o5x7uu1i">
      <div className="mx-auto w-full max-w-5xl px-5 py-16 sm:px-8 sm:py-24 lg:py-32" data-id="element-96" data-mp="han3yqa0gpwe">
        <p className="text-[0.68rem] font-semibold uppercase tracking-[0.22em] text-ember" data-id="element-97" data-mp="h8k6xmafxwi6">
          El proceso
        </p>
        <h2 id="glute-como" className="mt-5 text-[1.75rem] font-extrabold uppercase leading-[1.05] tracking-tight text-white sm:text-4xl" data-id="element-98" data-mp="qb1tk1u0cr5p">
          Cómo funciona
        </h2>

        <ol className="mt-10 grid gap-8 sm:grid-cols-3 sm:gap-10" data-id="element-99" data-mp="101o1razeafed">
          {gluteSteps.map((step, index) => <li key={step.title} className="border-t border-coal-line pt-5" data-id="element-100" data-mp="v1rzbg6ciw0x" data-mpi={index}>
              <span className="text-sm font-semibold tabular-nums text-ember" aria-hidden="true" data-id="element-101" data-mp="191jfnnkc4oi3">
                0{index + 1}
              </span>
              <h3 className="mt-2 text-lg font-bold uppercase tracking-tight text-white" data-id="element-102" data-mp="151sk76jv5k78">
                {step.title}
              </h3>
              <p className="mt-2 text-[0.93rem] leading-relaxed text-white/50 sm:text-base" data-id="element-103" data-mp="1tyqv1ne2d7no">
                {step.text}
              </p>
            </li>)}
        </ol>

        <p className="mt-14 max-w-3xl border-l-2 border-ember pl-5 text-[1.02rem] leading-relaxed text-white/60 sm:mt-16 sm:pl-7 sm:text-lg" data-id="element-104" data-mp="1yzwoxojgn0ys">
          En los primeros <strong className="font-semibold text-white" data-id="element-105" data-mp="28uyf8nph292y">7 días</strong> notarás que
          tus glúteos se sienten más firmes y llenos incluso sin entrenar: tu sistema nervioso
          volvió a encender el tono muscular basal.
        </p>
      </div>
    </section>;
}